// extracted by mini-css-extract-plugin
export default {"root":"DSLM7cccXyTfCkB5kb8w","wrap":"eOFkhdhqnbrn7fzw4GcJ","table-wrap":"zwvhR4OMORu8WRtwBTSu","tableWrap":"zwvhR4OMORu8WRtwBTSu"};